import React, { useCallback } from "react";
import PersonDetailPage from "./components/PersonDetailPage";
import { useNetworkPermissions, useNetworkService } from "./hooks/useNetworkRecords";
import { CLIENTS_HOME } from "./constants/networkEndpoints";

const CONFIG = { noun: "Client", plural: "Clients", home: CLIENTS_HOME, canEditRecords: true };

/** /partner/network/clients/:Id */
const ClientDetailPage = () => {
  const service = useNetworkService();
  const permissions = useNetworkPermissions();
  const load = useCallback(() => service.listClients(), [service]);
  const remove = useCallback((id) => service.removeClient(id), [service]);

  return <PersonDetailPage config={CONFIG} load={load} remove={remove} permissions={permissions} />;
};

export default ClientDetailPage;
